import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import './autoki-piano.css'

const AutokiPiano = (props) => {
    const history = useHistory()
    const [notes] = useState([
        { name: 'C', frequency: 262 },
        { name: 'D', frequency: 294 },
        { name: 'E', frequency: 330 },
        { name: 'F', frequency: 349 },
        { name: 'G', frequency: 392 },
        { name: 'A', frequency: 440 },
        { name: 'B', frequency: 494 },
    ])
    const [playingNote, setPlayingNote] = useState(null)
    const [octave, setOctave] = useState(4)

    useEffect(() => {
        // Initialize audio context
        if (!window.audioContext) {
            window.audioContext = new (
                window.AudioContext || window.webkitAudioContext
            )()
        }
    }, [])

    const handleBack = () => {
        history.push('/appMode/selectHardware')
    }

    const playNote = (note) => {
        setPlayingNote(note.name)

        // Send note to device via WebSerial
        // Example: sendCommand(`NOTE:${note.name}${octave}:${note.frequency}`)

        // For demo, use Web Audio API
        try {
            const audioContext = window.audioContext
            const oscillator = audioContext.createOscillator()
            const gainNode = audioContext.createGain()

            oscillator.connect(gainNode)
            gainNode.connect(audioContext.destination)

            oscillator.frequency.value =
                note.frequency * Math.pow(2, octave - 4)
            oscillator.type = 'sine'

            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
            gainNode.gain.exponentialRampToValueAtTime(
                0.01,
                audioContext.currentTime + 0.5
            )

            oscillator.start(audioContext.currentTime)
            oscillator.stop(audioContext.currentTime + 0.5)

            setTimeout(() => setPlayingNote(null), 500)
        } catch (error) {
            console.log('Web Audio not available, using fallback')
            setTimeout(() => setPlayingNote(null), 300)
        }

        console.log(`Playing note: ${note.name}${octave}`)
    }

    const handleOctaveUp = () => {
        if (octave < 8) {
            setOctave(octave + 1)
        }
    }

    const handleOctaveDown = () => {
        if (octave > 0) {
            setOctave(octave - 1)
        }
    }

    return (
        <div className="autoki-piano-container">
            <div className="piano-header">
                <h1>Autoki Piano</h1>
                <button onClick={handleBack} className="back-btn">
                    ← Back
                </button>
            </div>

            <div className="piano-content">
                <div className="octave-control">
                    <button
                        onClick={handleOctaveDown}
                        disabled={octave <= 0}
                        className="octave-btn"
                    >
                        ⬇️ Down
                    </button>
                    <div className="octave-display">
                        <span>
                            Octave: <strong>{octave}</strong>
                        </span>
                    </div>
                    <button
                        onClick={handleOctaveUp}
                        disabled={octave >= 8}
                        className="octave-btn"
                    >
                        ⬆️ Up
                    </button>
                </div>

                <div className="keyboard">
                    {notes.map((note) => (
                        <button
                            key={note.name}
                            className={`piano-key ${
                                playingNote === note.name ? 'playing' : ''
                            }`}
                            onClick={() => playNote(note)}
                            onMouseDown={() => playNote(note)}
                        >
                            <div className="note-name">{note.name}</div>
                            <div className="note-frequency">
                                {(
                                    note.frequency * Math.pow(2, octave - 4)
                                ).toFixed(0)}{' '}
                                Hz
                            </div>
                        </button>
                    ))}
                </div>

                <div className="keyboard-info">
                    <p>Click or press any key to play a note</p>
                    <p>Use octave controls to change the pitch range</p>
                </div>
            </div>
        </div>
    )
}

export default AutokiPiano
